import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Loader from "../components/Loader";

const PokemonPage = ({ match }) => {
  const [pokemonDetails, setPokemonDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  const id = match.params.id;

  useEffect(() => {
    const getPokemonData = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(
          `https://pokeapi.co/api/v2/pokemon/${id}`
        );
        setPokemonDetails(data);
      } catch (error) {
        console.error("Failed to fetch pokemon data:", error);
        // Handle the error as needed
      } finally {
        setLoading(false);
      }
    };
    getPokemonData();
  }, [id]);

  if (loading) return <Loader />;

  return (
    <Row>
      <Col xs={12}>
        <Card
          className="my-3 p-3 rounded text-center shadow p-3 mb-5 bg-white"
          style={{ border: "none" }}
        >
          {/* Pokemon Image and Name */}
          <Link to={`/pokemon/${pokemonDetails.id}`}>
            <Card.Img
              style={{ width: "15rem" }}
              src={pokemonDetails.sprites.front_default}
              variant="top"
            />
          </Link>
          <Card.Body
            className={`${pokemonDetails.types[0].type.name} rounded text-white`}
          >
            <Link to={`/pokemon/${pokemonDetails.name}`} className="link-name">
              <Card.Title as="div">
                <strong>
                  #{pokemonDetails.id}{" "}
                  {pokemonDetails.name.charAt(0).toUpperCase() +
                    pokemonDetails.name.slice(1)}
                </strong>
              </Card.Title>
            </Link>
          </Card.Body>
        </Card>
        <Card
          className="p-3 rounded text-center shadow p-3 mb-5 bg-white"
          style={{ border: "none" }}
        >
          {/* Height and Weight */}
          <Row className="text-center">
            <Col xs={12}>
              <h6>Height: {pokemonDetails.height * 0.1} m</h6>
              <h6>Weight: {pokemonDetails.weight * 0.1} kg</h6>
            </Col>
          </Row>
          {/* Base Stats */}
          <Row className="text-center">
            <Col xs={12}>
              <strong>
                <h5 style={{ background: "#f0f0f0" }}>Base Stats:</h5>
              </strong>
              {pokemonDetails.stats.map((stat) => (
                <div key={stat.stat.name}>
                  {stat.stat.name}: {stat.base_stat}
                </div>
              ))}
            </Col>
          </Row>
          {/* Abilities */}
          <Row className="text-center">
            <Col xs={12}>
              <h5 style={{ background: "#f0f0f0" }}>Abilities:</h5>
              {pokemonDetails.abilities.map((a) => (
                <div
                  key={a.ability.name}
                  className={`rounded px-4 py-1 my-1`}
                  style={{ background: "#f0f0f0" }}
                >
                  {a.ability.name.toUpperCase()}
                </div>
              ))}
            </Col>
          </Row>
          <Button variant="primary" className="mt-3">
            <Link to="/" style={{ color: "white", textDecoration: "none" }}>
              Back to Home
            </Link>
          </Button>
        </Card>
      </Col>
    </Row>
  );
};

export default PokemonPage;
